import React, { Component } from "react";
import { getBaseURL } from "components/helpers/HostURLHelper.jsx";
import ScheduleTestCard from "../core/ScheduleTestCard.jsx";
import { withStyles } from "@material-ui/core/styles";

import MuiTable from "../core/MuiTable.jsx";
import qs from "query-string";
import { formatDate } from "components/helpers/DateTimeHelper.jsx";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ComboBox from "../core/ComboBox.jsx";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";


const styles = (theme) => ({
  section: {
    padding: "16px 0",
    [theme.breakpoints.down("sm")]: {
      padding: "16px 0",
    },
  },
  filters: {
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
    marginTop: "16px",
    marginBottom: "16px"
  },
  filterSection: {
    paddingTop: "32px",
    marginRight: "16px",
    [theme.breakpoints.down("xs")]: {
      margin: "0px",
      padding: "16px 0 0",
    },
  },
});

class AnalystTestQuestionsReport extends Component {
  state = {
    schedule_data: "",
    columns: ["Question", "Correct", "Incorrect", "Unattempted"],
    rows: [],
    errorMessages: [],
    tabs: [],
    subjectTab: 0,
    allSubArray: [],
    totalStudents: 0,
    paper_id: "",
  allBranches: [],
  allSections: [],
  selectedBranch: "",
  selectedSection: ""
  };

  componentDidMount() {
    const paper_id = qs.parse(this.props.location.search).paper_id;
  this.setState({ paper_id }, () => {
    this.fetchFilters();
    this.fetchReportData();
  });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      const paper_id = qs.parse(this.props.location.search).paper_id;
      this.setState({ paper_id }, () => {
        this.fetchReportData();
      });
    }
  }

  fetchFilters = () => {
    const { paper_id } = this.state;
    $.get(getBaseURL() + `/analysis/branches-sections.json?paper_id=${paper_id}`).done((data) => {
      const allBranches = [{ name: "All", branch_id: "" }, ...data.branches.map(b => ({ name: b.name, branch_id: b.id }))];
      const allSections = [{ name: "All", section_id: "" }, ...data.sections.map(s => ({ name: s.name, section_id: s.id }))];
      this.setState({ allBranches, allSections });
    });
  };

  fetchReportData = () => {
    const { paper_id, selectedBranch, selectedSection } = this.state;
    const params = new URLSearchParams({
      paper_id,
      branch_id: selectedBranch,
      section_id: selectedSection,
    });
  
    $.get(getBaseURL() + `/analysis/test/question-analysis.json?` + params.toString())
      .done((data) => {
        this.processDataForTable(data?.question_analysis);
        this.processDataForScheduleCard(data?.schedule_data);
      })
      .fail((jqXHR) => {
        const errorMessages = this.state.errorMessages;
        errorMessages.push({ message: jqXHR["responseJSON"].message });
        this.setState({ errorMessages: jqXHR["responseJSON"].message });
      });
  };
  

  processDataForTable = (question_analysis) => {
    const subjects = Object.keys(question_analysis || {});
    const allRows = [];
  
    const allSubArray = subjects.map((sub) => {
      const questions = question_analysis[sub];
      if (Array.isArray(questions)) {
        const rows = questions.map((q) => {
          const row = [q.question_no, q.correct, q.incorrect, q.unattempted, sub];
          allRows.push([...row, sub]); // Add subject to "All" view
          return row;
        });
        return rows;
      } else {
        console.warn(`Expected array for subject '${sub}', got:`, questions);
        return [];
      }
    });
  
    // Add 'All' tab at the beginning
    const allColumns = ["Q.No", "Correct", "Incorrect", "Unattempted", "Subject"];
    const tabs = ["All", ...subjects];
    const allSubArrayWithAll = [allRows, ...allSubArray];
  
    this.setState({
      tabs: tabs,
      columns: allColumns,
      allSubArray: allSubArrayWithAll,
      rows: allRows
    });
  };

  processDataForScheduleCard(schedule_data) {
    const sdata = {
      name: schedule_data["schedule_name"],
      program: schedule_data["schedule_program"],
      test_type: schedule_data["schedule_test_type"],
      user_group: schedule_data["schedule_user_group"],
      start_time: formatDate(schedule_data["schedule_start_time"]),
      test_info_id: schedule_data["test_info_id"]
    };
    this.setState({ schedule_data: sdata, totalStudents: schedule_data?.total_students });
  }

  a11yProps(index) {
    return {
      id: `subject-tab-${index}`,
    };
  }

  handleSubjectTabChange = (event, newValue) => {
    this.setState({
      subjectTab: newValue,
      rows: this.state.allSubArray[newValue],
    });
  };

  getReportName(name) {
    return name ? "_" + name : "";
  }

  handleBranchChange = (e, option) => {
    this.setState({ selectedBranch: option?.branch_id || "" }, this.fetchReportData);
  };
  
  handleSectionChange = (e, option) => {
    this.setState({ selectedSection: option?.section_id || "" }, this.fetchReportData);
  };

  render() {
    const { classes } = this.props;
    const { schedule_data, columns, rows, tabs, subjectTab, totalStudents } =
      this.state;

    return (
      <React.Fragment>
        
        {schedule_data && <ScheduleTestCard data={schedule_data} />}
        <Button
          variant="contained"
          color="primary"
          disabled={!schedule_data?.test_info_id}
          onClick={() => {
            const testViewUrl = `/analysis/test/questions/view?test_id=${schedule_data?.test_info_id}&mode=view`;
            window.open(testViewUrl, "_blank");
          }}
          style={{ margin: "12px 0px 0px 0px"  }}
        >
          View All Questions
        </Button>
        <Grid container spacing={2} className={classes.filters}>
          <Grid item xs={6} sm={3}>
            <ComboBox options={this.state.allBranches} onChange={this.handleBranchChange} label="Filter by Branch" />
          </Grid>
          <Grid item xs={6} sm={3}>
            <ComboBox options={this.state.allSections} onChange={this.handleSectionChange} label="Filter by Section" />
          </Grid>
        </Grid>
        {tabs && tabs.length > 0 && (
          <div className={classes.section}>
            <Tabs value={subjectTab} onChange={this.handleSubjectTabChange}>
              {tabs.map((sub, index) => (
                <Tab label={sub} {...this.a11yProps(index)} />
              ))}
            </Tabs>
          </div>
        )}

        <div>
          <MuiTable
            columns={columns}
            rows={rows}
            title={`Question Analysis (Total Students: ${totalStudents})`}
            downloadTitle={
              "Question_Analysis" +
              this.getReportName(schedule_data?.name) +
              this.getReportName(tabs[subjectTab])
            }
            rowsPerPage={100}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(AnalystTestQuestionsReport);
